

























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { process as processText, escapeHtml } from '../../../common/MessageProcessor';

@Component
export default class TextFieldPlaceholder extends Vue {
    @Prop({ default: '' }) modificationName: string;
    @Prop({ required: true }) text: string;
    @Prop() placeholderText: string;

    isEditing = false;
    textLocal = '';

    created() {
        this.textLocal = this.text;
    }

    get showedText() {
        return (this.textLocal || this.placeholderText);
    }

    @Watch('text')
    onTextChanged() {
        this.textLocal = this.text;
    }

    async onTextClick() {
        this.isEditing = true;
        await this.$nextTick();
        (this.$refs["textarea"] as HTMLElement).focus();
    }

    onBlur() {
        this.isEditing = false;
        this.$emit('changed', this.textLocal);
    }

    onEscape() {
        this.isEditing = false;
        this.textLocal = this.text;
    }

    processText(text: string) {
        return processText(text);
    }

    escapeHtml(text: string) {
        return escapeHtml(text);
    }
}
